
export { photoTourReducer } from "./redux/photoTourSlice"